// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

if (document.querySelector('.splitview')) {
    document.addEventListener('DOMContentLoaded', function() {
        var parent = document.querySelector('.splitview'),
            topPanel = parent.querySelector('.top'),
            handle = parent.querySelector('.handle'),
            delta = 0;


       

    });
}

// Nav trigger
$(".nav-trigger").on("click", function(e) {
    e.preventDefault();

    $(document.body).toggleClass("nav-visible");

});


// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {

    if ($(this).data()["preventDefault"]) {
        e.preventDefault();
    }

    var params = [];

    if ($(this).attr("data-params")) {
        params = eval("[" + $(this).attr("data-params") + "]");
    }

    params.push(e);

    var controller = eval($(this).attr("data-controller"));
    controller.apply(this, params);
});


if($('.table-mobile-title')) {
    mobileTable('.table-mobile-title');
}

for(i = 1; i < 100; i++) {
    var className = '.table-mobile-title-' + i;
    if($(className)) {
        mobileTable(className);
    }
}

function mobileTable(className) {
    var values = [];
    var columns = $(className).find('thead').find('td');

    if(!columns) {
        columns = $(className).find('thead').find('th');
    }

    var rows = $(className).find('tbody').find('tr');
    
    $.each(columns, function(i, item) {
        values.push(item.innerHTML);
    });

    $.each(rows, function() {
        $.each($(this).find('td'), function(i) {
            $(this).attr('data-label', values[i]);
        });
    });
}

// $('.nav__link').on('click touchend', function(e) {
//     var el = $(this);
//     var link = el.attr('href');
//     window.location = link;
// });

function externalLinks() { 
    if (!document.getElementsByTagName) return; 

    var anchors = document.getElementsByTagName("a"); 
    
    for (var i = 0; i < anchors.length; i++) { 
        var anchor = anchors[i]; 
        
        if (anchor.getAttribute("href") && anchor.getAttribute("rel") == "external") anchor.target = "_blank"; 
    } 
}
    
window.onload = externalLinks;


// WEBPACK FOOTER //
// ./resources/assets/js/ui/common.js